import { render } from "./StorefrontProductGrid.vue?vue&type=template&id=edc0ff28&scoped=true"
import script from "./StorefrontProductGrid.vue?vue&type=script&lang=js"
export * from "./StorefrontProductGrid.vue?vue&type=script&lang=js"

import "./StorefrontProductGrid.vue?vue&type=style&index=0&id=edc0ff28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc0ff28"]])

export default __exports__